export default __webpack_public_path__ + "static/media/related1.b0887da4.svg";